import { Box } from "@mui/material";

const SvgIcon = ({
  icon,
  sizeInPx = "24",
  color = (theme) => theme.palette.widgetStyles.chatControls.iconColor,
}: {
  icon: string;
  sizeInPx?: string;
  color?: (theme: any) => string;
}): React.JSX.Element => (
  <Box
    data-testid="svg-icon-component"
    sx={{
      width: `${sizeInPx}px`,
      height: `${sizeInPx}px`,
      backgroundColor: color,
      mask: `url("${icon}") no-repeat center / contain`,
      WebkitMask: `url("${icon}") no-repeat center / contain`,
    }}
  />
);

export default SvgIcon;
